import type { FaireProductEntity } from "../../entity_types/product";

export const p_ps2q5zwjw2: FaireProductEntity = {
  token: "p_ps2q5zwjw2",
  type: "product",
  name: "Wine Knit Sweatshirt",
  brandToken: "b_cb45hc3s6w",
  brandName: "Southern Bliss Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/d5e484cd358a4dc53743129d0ba327a1861ac5b59cb2b38610a0ececd2c206bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19eb4778761f06489aeea9afabe47a16684fa3ebe234b72860aa3fbe3433148c.jpeg",
    "https://cdn.faire.com/fastly/85ad72c9b1d74b3eba278144541eea55140d03cd02d35d1204f99a0eb6d2e924.jpeg",
    "https://cdn.faire.com/fastly/dccc3d39f308051479a509341169228c466be76f5bac2264574bf69f9fc33243.jpeg",
    "https://cdn.faire.com/fastly/62d63e7e77640fb8196281ddc1856c33d5032f79d635b8e7610e9c7e660dc0dd.jpeg",
    "https://cdn.faire.com/fastly/9a0c0c0e74bd16b283f67c2d994bf61689d4bd58b1ea0b3895a96ee80720fe8e.jpeg",
  ],
  priceDollars: 36,
  description:
    "Cozy up in the kind of classic that never goes out of style! \n\nOur Wine Knit Sweatshirt is a unisex mid-weight oatmeal crewneck crafted in a plush, textured knit that’s as easy to wear as it is to love. Finished with ribbed cuffs and waistband for that timeless fit, it’s the perfect layer for slow mornings, last-minute Target runs, or your next wine night in. Pairs well with leggings, denim, and a full glass.\n",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:44.521Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
